import { render, staticRenderFns } from "./NarliFerryboatStatsByProcessTypeView.vue?vue&type=template&id=fa3063da&"
import script from "./NarliFerryboatStatsByProcessTypeView.vue?vue&type=script&lang=js&"
export * from "./NarliFerryboatStatsByProcessTypeView.vue?vue&type=script&lang=js&"
import style0 from "./NarliFerryboatStatsByProcessTypeView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports